import React from 'react';

const InterviewTipsSection = () => {
  const sections = [
    {
      id: 1,
      title: "Interview Tips",
      image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=600&h=400&fit=crop",
      imagePosition: "right",
      tips: [
        {
          number: 1,
          text: "Research the company: Thoroughly research the company, its values, mission, products or services, recent news, and key other relevant information. This demonstrates your genuine interest and helps you speak confidently about the company and demonstrate the job role's interest."
        },
        {
          number: 2,
          text: "Understand the job description: Carefully review the job description and understand the specific skills, qualifications, and experiences the employer is seeking. This will help you tailor your responses to highlight how your qualifications align with their needs."
        },
        {
          number: 3,
          text: "Prepare and practice: Anticipate common interview questions and prepare thoughtful responses. Practice your answers, focusing on concise and impactful delivery. Consider conducting mock interviews with a friend or family member to gain confidence and receive feedback. READ MORE"
        }
      ]
    },
    {
      id: 2,
      title: "Cover Letter",
      image: "https://images.unsplash.com/photo-1586281380349-632531db7ed4?w=600&h=400&fit=crop",
      imagePosition: "left",
      description: "Creating a powerful cover letter is an interview can greatly increase your chances of getting noticed by potential employers. Here are some key pointers to include when crafting your cover letter:",
      tips: [
        {
          number: 1,
          text: "Tailor the cover letter: Customize your cover letter for each job application. Research the company and the specific role to understand their needs, values, and goals. Then align your qualifications, skills, and experiences with what the company is looking for."
        },
        {
          number: 2,
          text: "Use a professional format: Use a professional, formal writing header and introduction. If possible, if you don't know the recipient's name, consider using a general salutation like \"Dear Hiring Manager\" or \"Dear Company Name Team.\" Let the paragraph that expresses your enthusiasm for the position and introduces yourself. Clearly state the position you are applying for and mention where you found the job listing. READ MORE"
        }
      ]
    },
    {
      id: 3,
      title: "Resume Writing",
      image: "https://images.unsplash.com/photo-1586281380117-5a60ae2050cc?w=600&h=400&fit=crop",
      imagePosition: "right",
      tips: [
        {
          number: 1,
          text: "Clear and organized structure: Use a clean and professional format with clear headings and sections. Start with your contact information, followed by a professional summary or objective statement. Then, include sections for your work experience, education, skills, and any additional relevant sections."
        },
        {
          number: 2,
          text: "Tailor it to the job: Customize your resume for each job application. Analyze the job description and identify the key skills and qualifications sought by the employer. Then, emphasize those relevant skills and experiences in your resume."
        },
        {
          number: 3,
          text: "Highlight achievements and results: Instead of simply listing your job responsibilities, focus on your accomplishments and the impact you made in previous roles. Use quantifiable metrics whenever possible to demonstrate your achievements. This statement should grab the reader's attention and encourage them to continue reading. READ MORE"
        }
      ]
    },
    {
      id: 4,
      title: "Virtual Interview Guide",
      image: "https://images.unsplash.com/photo-1588196749597-9ff075ee6b5b?w=600&h=400&fit=crop",
      imagePosition: "left",
      description: "Virtual interviews have become increasingly common, and knowing how to excel in this format is crucial to success. In today's job market, here are some tips to help you have a successful virtual interview:",
      tips: [
        {
          number: 1,
          text: "Test your technology: Prior to the interview, test your internet connection, webcam, microphone, and any video conferencing software or platform that will be used. Ensure that you have a stable internet connection and that your audio and video are working properly. Familiarize yourself with the platform and set up a well-lit and professional-looking background. Ensure that everything is working properly and that you have a backup connection."
        },
        {
          number: 2,
          text: "Dress professionally: Just because you're at home doesn't mean you should dress casually. Dress professionally as you would for an in-person interview. Consider using a neutral background or a virtual background if available. Make sure the area is free from distractions and allows others in your household to know that you're in an interview."
        },
        {
          number: 3,
          text: "Dress professionally: Dress as you would for an in-person interview. Wear professional attire that is appropriate for the company culture and the position you're applying for. READ MORE"
        }
      ]
    }
  ];

  return (
    <div className="bg-white">
      <div className="w-full max-w-[1400px] mx-auto px-6">
        {sections.map((section, index) => (
          <div key={section.id}
          className='pb-12'>
            {/* Section Title */}
            <h2 data-aos="fade-up" data-aos-duration="1000" className="text-3xl sm:text-4xl font-semibold font-SpaceGrotesk text-primaryColor mb-8">
              {section.title}
            </h2>

            {/* Description if exists */}
            {section.description && (
              <p data-aos="fade-up" data-aos-duration="1000" className="text-gray-600 mb-8 leading-relaxed">
                {section.description}
              </p>
            )}

            {/* Content Grid */}
            <div className={`grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-start`}>
              {/* Image Section */}
              <div className={`${section.imagePosition === 'right' ? 'lg:order-2' : 'lg:order-1'}`}>
                <div data-aos="fade-up-left" data-aos-duration="1000" className="rounded-lg overflow-hidden shadow-lg sticky top-8">
                  <img
                    src={section.image}
                    alt={section.title}
                    className="w-full h-auto object-cover"
                  />
                </div>
              </div>

              {/* Tips Section */}
              <div className={`${section.imagePosition === 'right' ? 'lg:order-1' : 'lg:order-2'}`}>
                <div className="space-y-6">
                  {section.tips.map((tip,index) => (
                    <div data-aos="fade-up" data-aos-duration="1000" data-aos-delay={index * 100} key={tip.number} className="flex gap-4">
                      <div className="flex-shrink-0">
                        <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-blue-600 text-white text-sm font-semibold">
                          {tip.number}
                        </span>
                      </div>
                      <div className="flex-1">
                        <p className="text-gray-700 leading-relaxed">
                          {tip.text}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InterviewTipsSection;